<template>
  <div>
    <v-data-table
        :loading="loading"
        hide-default-footer
        disable-pagination
        :headers="headers"
        :items="items">
      <template #item.amount="{item}">
        {{ item.total_paid | money }}
      </template>
      <template #item.payment_type="{item}">
        {{ item['transactions_debit'].payment_type | parsePaymentType }}
      </template>
      <template #item.payment_date="{item}">
        {{ item['transactions_debit'].created_at | parseDate }}
      </template>
      <template #item.initial="{item}">
        {{ item.is_initial_payment ? 'Да' : 'Нет' }}
      </template>
      <template #item.print="{item: {status, id}}">
        <v-btn @click="printHistory(id)" v-if="status === 10" class="action-btn" color="primary">
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </template>
      <template #item.status="{item}">
        <v-sheet class="d-inline-block rounded px-2 py-1" dark :color="parseTransaction(item.status).color">
          {{ parseTransaction(item.status).text }}
        </v-sheet>
      </template>
    </v-data-table>

    <v-pagination
        v-if="lastPage > 1"
        @input="getDebits"
        v-model="params.page"
        :length="lastPage"
    ></v-pagination>

    <div class="a4__size" id="history-print-page" v-show="false">
      <div class="check__wrapper" v-if="selectedTransfer">
        <div class="check__wrapper-left">
          <div class="table__main">
            <table>
              <tbody>
              <tr>
                <td colspan="3">ООО "{{ selectedTransfer.mko }}"</td>
              </tr>
              <tr>
                <td colspan="3" class="border__none"></td>
              </tr>
              <tr>
                <td colspan="3">{{ selectedTransfer.date }}</td>
              </tr>
              <tr>
                <td colspan="3" class="border__none"></td>
              </tr>
              <tr>
                <td>Корреспон-субсчёт</td>
                <td>Тулов тури</td>
                <td>Сумма ракам билан</td>
              </tr>
              <tr class="border-bottom">
                <td>Кредит товар</td>
                <td>{{ selectedTransfer.payment_type }}</td>
                <td>{{ selectedTransfer.amount_word }}</td>
              </tr>
              <tr>
                <td colspan="3" class="border__none"></td>

              </tr>
              <tr>
                <td class="" colspan="3">{{ selectedTransfer.full_name }}</td>

              </tr>
              <tr>
                <td colspan="3">{{ selectedTransfer.amount_word }}</td>
              </tr>
              <tr>
                <td colspan="3">{{ selectedTransfer.credit_date }} {{ selectedTransfer.credit_number }},
                  {{ selectedTransfer.details }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="check__wrapper-right cutting__line">
          <div class="table__main">
            <table>
              <tbody>
              <tr>
                <td>ООО "{{ selectedTransfer.mko }}"</td>
              </tr>
              <tr>
                <td class="border__none"></td>
              </tr>
              <tr>
              <tr>
                <td class="border__none"></td>
              </tr>
              <tr>
                <td>{{ selectedTransfer.full_name }}</td>
              </tr>
              <tr>
                <td class="border__none"></td>
              </tr>
              <tr>
                <td>{{ selectedTransfer.amount }}</td>
              </tr>
              <tr>
                <td>{{ selectedTransfer.amount_word }}</td>
              </tr>
              <tr>
                <td>{{ selectedTransfer.credit_number }}</td>
              </tr>

              <tr>
                <td>{{ selectedTransfer.date }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {TRANSACTION_STATUS} from "@/utils/constants"
import moment from "moment"
import numberToWordsUz from "number-to-words-uz"

export default {
  name: 'history-transfer-table',
  props: {
    creditId: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      headers: [
        {
          text: 'Сумма',
          value: 'amount'
        },
        {
          text: 'Тип платежа',
          value: 'payment_type'
        },
        {
          text: 'Сумма первоначального взноса',
          value: 'initial'
        },
        {
          text: 'Дата платежа',
          value: 'payment_date'
        },
        {
          text: 'Статус',
          value: 'status'
        },
        {
          text: 'Печать',
          value: 'print'
        }
      ],
      selectedTransfer: null,
      params: {
        page: 1
      },
      lastPage: 0
    }
  },

  methods: {
    reInit() {
      this.items = []
      this.lastPage = 0
      this.params = {page: 1}
      this.getDebits()
    },
    async getDebits() {
      this.loading = true
      try {
        const {data: {data, links}} = await this.$http.get(`admin/debit-history/${this.creditId}`, {
          params: this.params
        })
        this.items = data
        this.lastPage = links.last_page
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.loading = false
      }
    },
    async printHistory(id) {
      try {
        this.$showLoading()
        const FORMAT_DATE = 'DD.MM.YYY HH:mm:ss'
        const {data: {data}} = await this.$http(`admin/credit/history/payment/${id}`)
        data.date = moment(data.date).format(FORMAT_DATE)
        data.credit_date = moment(data.credit_date).format(FORMAT_DATE)
        data.amount_word = numberToWordsUz.convert(data.amount, {lang: "uzCyril"});

        this.selectedTransfer = data
        this.$nextTick(() => {
          this.$htmlToPaper('history-print-page')
        })
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    parseTransaction(val) {
      let transaction = TRANSACTION_STATUS.find(item => item.value === val)
      if (!transaction) return {text: ''}
      return {
        text: transaction.text,
        color: transaction.color
      }
    }
  },
  created() {
    this.getDebits()
  }
}
</script>
